var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_shadow"},[_c('div',{staticClass:"page_cover pdf-page"},[_vm._m(0),_c('div',{staticClass:"main"},[_c('p',[_vm._v("姓       名："+_vm._s(_vm.name))]),_c('p',[_vm._v("报告编号："+_vm._s(_vm.reportNum))]),_c('p',[_vm._v("报告时间："+_vm._s(_vm.updatedAt))])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('h3',[_vm._v("升学建议方案")])])
}]

export { render, staticRenderFns }